import _ from 'lodash';
import produce from 'immer';
import { SELECTION_TYPES, pushClickedElementToAdmin } from 'client/components/common/SelectionHint/utils';

const getSelectedComponentProps = props => _.pick(props, ['uiConfig', 'type', 'editableModeProps', '_id', 'symbol']);

export class SelectionHintController {
	static FOCUS = 'focus';

	static SELECT = 'select';

	static DESELECT = 'deselect';

	constructor(props) {
		/**
		 * @function
		 *
		 * @param {Object}  props
		 * @param {String}  props.type              - one of SELECTION_TYPES values
		 * @param {Object}  [props.data]            - action data
		 * @param {Boolean} [props.isMultiSelect]   - is selected multiple blocks
		 *
		 * @returns CurrentSelection
		 */
		// @ts-expect-error ts-migrate FIXME
		this.action = props.action;
		// @ts-expect-error ts-migrate FIXME
		this.multiSelections = [];
	}

	/**
	 * Use it just to update SelectionHint view (NOTE: Supported only single selected node)
	 * @param e {MouseEvent}
	 * @param type {String} selection hint type
	 * @param compProps {Object} props of the selected component
	 */
	focus = (e, type, compProps) => {
		const { currentTarget } = e;
		const { id } = currentTarget;
		// @ts-expect-error ts-migrate FIXME
		this.action({ type: SELECTION_TYPES.clicked, data: { id, ...getSelectedComponentProps(compProps) } });
	};

	/**
	 * Use it to update SelectionHint view and admin state of the selected element
	 * (NOTE: Supported single|multiple selected node)
	 * @param e {MouseEvent}
	 * @param e.currentTarget
	 * @param type {String} selection hint type
	 * @param compProps {Object} props of the selected component
	 * @param compProps.uiConfig {Object}
	 * @param compProps.type {String}
	 * @param compProps._id {String}
	 * @param compProps.editableModeProps {Object}
	 * @param compProps.editableModeProps.inheritance {Object}
	 * @param compProps.editableModeProps.nodeProps {Object}
	 * @param compProps.editableModeProps.nodeProps.data-path {String}
	 * @param stage {String|undefined} SELECTION_STAGE
	 */
	select = async (e, type, compProps, stage) => {
		let selection;
		const isMultiSelect = e.shiftKey && type === SELECTION_TYPES.clicked;

		if (e.totalSelected > 1) {
			/*
			 Await until all selected node are being updated and then push to the store all of them in a one bunch.
			 When elements are updated traverseTree provides an updates to the components and each related to component
			 <SelectedComponentWatcher> in his didUpdate lifecycle triggers select event on myself
			 */

			/*
			 Why can be old index?
			 may be caused when update triggered more than one time on the same node, but shouldn't happen
			 */
			// @ts-expect-error ts-migrate FIXME
			const oldIndex = _.findIndex(this.multiSelections, ['id', e.currentTarget.id]);
			const data = {
				id: e.currentTarget.id,
				...getSelectedComponentProps(compProps),
			};

			// @ts-expect-error ts-migrate FIXME
			if (oldIndex > -1) this.multiSelections[oldIndex] = data;
			// @ts-expect-error ts-migrate FIXME
			else this.multiSelections.push(data);

			// @ts-expect-error ts-migrate FIXME
			if (this.multiSelections.length === e.totalSelected) {
				// Store data in "redux" to render SelectionHint component based on it
				// @ts-expect-error ts-migrate FIXME
				selection = await this.action({
					type,
					isMultiSelect,
					// @ts-expect-error ts-migrate FIXME
					data: this.multiSelections,
				});

				// clear multiSelection
				// @ts-expect-error ts-migrate FIXME
				this.multiSelections = [];
			} else {
				return;
			}
		} else {
			// Store data in "redux" to render SelectionHint component based on it
			// @ts-expect-error ts-migrate FIXME
			selection = await this.action({
				type,
				isMultiSelect,
				data: {
					id: _.get(e, 'currentTarget.id') || compProps.uiConfig.nodeProps.id,
					...getSelectedComponentProps(compProps),
					selectionStage: stage,
				},
			});
		}

		if (type === SELECTION_TYPES.clicked) {
			// Transmit to admin CardEditor computed data + inheritance of the clicked element
			const selectionClicked = selection[SELECTION_TYPES.clicked];

			/* eslint-disable no-param-reassign */
			const payload = produce(selectionClicked, draft => {
				_.forOwn(draft, selectedComponent => {
					const path = selectedComponent.editableModeProps.nodeProps['data-path'];
					const { inheritance } = selectedComponent.editableModeProps;

					selectedComponent.inheritance = inheritance;
					selectedComponent.path = path;

					delete selectedComponent.id;
					delete selectedComponent.editableModeProps;
				});
			});
			/* eslint-enable no-param-reassign */

			// why defer: finish all tasks with a current element and then select another one
			_.defer(() => {
				pushClickedElementToAdmin(payload);
			});
		}
	};

	/**
	 * @param e {MouseEvent}
	 * @param type {String} selection hint type
	 */
	deselect = (e, type) => {
		// @ts-expect-error ts-migrate FIXME
		this.action({ type });

		if (type === SELECTION_TYPES.clicked || !type) {
			pushClickedElementToAdmin({});
		}
	};
}
